/*********************** Custom JS for Boost AI Search & Discovery  ************************/
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('CTAButton', {
            name: 'Modify Product CTAButton',
            enabled: true,
            apply: () => ({
                props: (props, element) => {
                    try {
                      const data = element.getParentElm().getParentElm().getParams().props.product;
                      if(data.tags.includes('easy-bundle') || data.tags.includes('personalise-my-bottle')){
                        if(props.action == "quickAddToCart" || props.buttonType == "selectOptionBtn"){
                          props.onClick = () => {
                            window.location.href = '/products/' + data.handle;
                          }
                          if(data.tags.includes('easy-bundle')){
                            props.text = 'Build My Set';
                          }

                          if(data.tags.includes('personalise-my-bottle')){
                            props.text = 'Personalise My Bottle';
                          }
                          
                        }else{
                          props.disabled = true;
                        }
                      }
                      return props;
                    } catch (error) {
                      console.log(error);
                    }
                },
                afterRender(element) {
                    // Get the nearest parent ProductItem element
                },
            }),
        });
        componentRegistry.useComponentPlugin("HeaderTitle", {
            name: "Move Collection HeaderTitle To Sidebar",
            apply: () => {
                return {
                    afterInit(element) {
                      try {
                          // Move Title
                          if (window.innerWidth >= 768) {
                            const titleElement = document.querySelector('.boost-sd__header-title');
                            if(titleElement){
                              document.querySelector('.boost-sd-left').insertAdjacentElement("afterbegin", titleElement);
                            }
                          }
                        } catch (e) {
                        // console.warn(e);
                     }
                  },

                };
            },
        });
        componentRegistry.useComponentPlugin("HeaderDescription", {
            name: "Move Collection Description To Sidebar",
            apply: () => {
                return {
                    afterInit(element) {
                      try {
                          // Move description
                          if (window.innerWidth >= 768) {
                            const descriptionElement = element.getRootElm();
                            if (descriptionElement) {
                              document.querySelector('.boost-sd-left .boost-sd__header-title').insertAdjacentElement("afterend", descriptionElement);
                              setTimeout(function() {
                                initReadMore('.boost-sd-left .boost-sd__header-description', {
                                		collapsedHeight: 90,
                                		speed: 100,
                                		heightMargin: 16,
                                		moreLink: '<div style="margin-bottom: 15px; padding: 0 16px;" class="btn-readmore"><a href="#"><b>Read more</b></a></div>',
                                		lessLink: '<div style="margin-bottom: 15px; padding: 0 16px;" class="btn-close"><a href="#"><b>Close</b></a></div>'
                                });
                              },300);
                            }
                          }
                        } catch (e) {
                        // console.warn(e);
                     }
                  },

                };
            },
        });
    }
]);